import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ServicesGrid from './components/ServicesGrid';
import ProcessSection from './components/ProcessSection';
import JsonLd from '../../components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://devstander.com';

const servicesJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebPage',
      '@id': `${siteUrl}/services#webpage`,
      url: `${siteUrl}/services`,
      name: 'Software Development Services | Devstander Warsaw',
      description:
        'From concept to production – end-to-end software development services in Warsaw: web apps, mobile apps, cloud, architecture, QA, and legacy modernization.',
      isPartOf: { '@id': `${siteUrl}/#website` },
    },
    {
      '@type': 'ItemList',
      name: 'Devstander Software Development Services',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Investigation & Analysis' },
        { '@type': 'ListItem', position: 2, name: 'Web Application Development' },
        { '@type': 'ListItem', position: 3, name: 'Mobile App Development' },
        { '@type': 'ListItem', position: 4, name: 'Software Architecture & Design' },
        { '@type': 'ListItem', position: 5, name: 'Cloud & DevOps Solutions' },
        { '@type': 'ListItem', position: 6, name: 'Quality Assurance & Testing' },
        { '@type': 'ListItem', position: 7, name: 'Legacy System Modernization' },
        { '@type': 'ListItem', position: 8, name: 'Long-Term Partnership' },
      ],
    },
  ],
};

export default function Services() {
  return (
    <>
      <JsonLd data={servicesJsonLd} />
      <Navbar />
      <main>
        {/* Page Hero */}
        <section className="relative bg-[#070B14] pt-32 pb-20 overflow-hidden">
          <div className="absolute inset-0">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-[#3B82F6]/5 rounded-full blur-3xl pointer-events-none"></div>
          </div>
          <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
            <div className="max-w-2xl">
              <div className="flex items-center gap-2 mb-5">
                <span className="w-6 h-px bg-[#3B82F6]"></span>
                <span className="text-[#3B82F6] text-xs font-semibold uppercase tracking-widest">
                  What We Offer
                </span>
              </div>
              <h1 className="font-display text-4xl lg:text-5xl font-bold text-white leading-tight mb-5 text-balance">
                Our Services
              </h1>
              <p className="text-slate-400 text-lg leading-relaxed max-w-xl">
                From concept to production – we provide end-to-end software development
                services tailored to your business needs.
              </p>
            </div>
          </div>
        </section>

        <ServicesGrid />
        <ProcessSection />

        {/* CTA */}
        <section className="bg-[#070B14] py-24">
          <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
            <div className="flex items-center justify-center gap-2 mb-5">
              <span className="w-6 h-px bg-[#3B82F6]"></span>
              <span className="text-[#3B82F6] text-xs font-semibold uppercase tracking-widest">
                Get Started
              </span>
              <span className="w-6 h-px bg-[#3B82F6]"></span>
            </div>
            <h2 className="font-display text-3xl lg:text-4xl font-bold text-white mb-4 text-balance">
              Have a Project in Mind?
            </h2>
            <p className="text-slate-400 mb-8 max-w-lg mx-auto">
              Let&apos;s talk about your requirements and find the best way to bring your idea to life.
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 bg-[#3B82F6] hover:bg-[#2563EB] text-white font-semibold px-8 py-3.5 rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              Contact Us
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
